import BaseValidator from '@/lib/data/validator/BaseValidator'

export default class ElectionResultsValidator extends BaseValidator {
  validatorRules = {
    'Candidates.*.Votes': {
      required: true,
      type    : BaseValidator.Type.Numeric
    }
  }

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor (data = {}) {
    super(data)
  }
}
